import React, { Component } from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';
import 'react-table/react-table.css';
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import './Carriers-List.scss';


class CarriersList extends Component {

    constructor() {
        super();

        this.getCarriersList = this.getCarriersList.bind(this);
        this.toggleModalNovaTransportadora = this.toggleModalNovaTransportadora.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.declaracao = this.declaracao.bind(this);
        this.cadastrarTransportadora = this.cadastrarTransportadora.bind(this);
        this.handleError = this.handleError.bind(this);

        this.handleError = this.handleError.bind(this);


        this.Configurations = new Configurations();

        this.state = {
            carriersList: [],
            modalNovaTransportadora: false,
            nomeTransportadora: '',
            declaracao: false,
            isLoadingCadastrarTransp: false
        };

        this.columns = [
            {
                Header: 'Id',
                accessor: 'idTransportadora',
                className: 'text-center pointer',
                width: 40
            },
            {
                Header: 'Nome',
                accessor: 'nome',
                className: 'text-center pointer',
                width: 200
            },
            {
                id: 'declaracao',
                Header: 'Declaração',
                accessor: d => {
                    return (<i className={`fas ${d.declaracao === 1 ? 'fa-check text-primary' : 'fa-times text-danger'}`}></i>)
                },
                className: 'text-center pointer',
                width: 100
            },
            {
                id: 'dtCriacao',
                Header: 'Data Criação',
                accessor: d => {
                    return moment(d.dtCriacao)
                        .local()
                        .format("DD/MM/YYYY HH:mm:ss")
                },
                className: 'text-center pointer',
                width: 180
            },
        ];
    }



    async getCarriersList(o) {
        const _carriers = axios.get(this.Configurations.apiBasePath + `/logistica/transportadoras`);

        _carriers.then(response => {
            this.setState({
                carriersList: response.data.transportadoras,
                loading: false
            });
        }).catch(err => {
            console.log(err);
        });
    }

    toggleModalNovaTransportadora() {
        this.setState({ modalNovaTransportadora: !this.state.modalNovaTransportadora })
    }

    handleChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }

    declaracao() {
        this.setState({ declaracao: !this.state.declaracao });
    }

    cadastrarTransportadora() {
        this.setState({ isLoadingCadastrarTransp: true })
        const _novaTransportadora = {
            nome: this.state.nomeTransportadora,
            isDeclaracao: this.state.declaracao
        }
        axios.post(this.Configurations.apiBasePath + `/logistica/transportadoras/nova`, _novaTransportadora)
            .then(response => {
                this.setState({
                    nomeTransportadora: '',
                    declaracao: false,
                })
                this.toggleModalNovaTransportadora();
                this.getCarriersList();
            }).catch(this.handleError).finally(() => this.setState({ isLoadingCadastrarTransp: false }))
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.message : 'Erro inesperado.' })
    }

    render() {
        return (
            <div className="carriers-list">
                <div className="row">
                    <div className="col-9">
                        <h2 className="title-1">Transportadoras</h2>
                    </div>
                    <div className="col-3 text-right">
                        <button className="btn btn-outline-success" onClick={this.toggleModalNovaTransportadora}>Nova transportadora</button>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <ReactTable
                                    data={this.state.carriersList}
                                    columns={this.columns}
                                    onFetchData={this.getCarriersList}
                                    defaultPageSize={20}
                                    pages={this.state.pages}
                                    manual
                                    loading={this.state.loading}
                                    className="-striped -highlight"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando...'
                                    noDataText='Nenhuma transportadora encontrada.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                    getTdProps={(state, rowInfo, column, instance) => {
                                        return {
                                            onClick: (e, handleOriginal) => {
                                                if (rowInfo) {
                                                    if (column.id === "desativar") handleOriginal();
                                                }
                                            }
                                        }
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                </div>
                <Modal className="modal-new-carrier" isOpen={this.state.modalNovaTransportadora} toggle={this.toggleModalNovaTransportadora}>
                    <ModalHeader toggle={this.toggleModalNovaTransportadora}>Cadastro de nova transportadora</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-12 py-3">
                                <label>Nome da transportadora</label>
                                <input name="nomeTransportadora" type="text" className="form-control" autoComplete="off" value={this.state.nomeTransportadora} onChange={this.handleChange}></input>
                            </div>
                            <div className="col-12 text-left">
                                <input type="checkbox" className="check-box" onChange={this.declaracao} checked={this.state.declaracao} />
                                <label onClick={this.declaracao} className="mx-2 pointer">Declaração</label>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingCadastrarTransp ? (
                            <div className="col-12 text-right">
                                <div className="spinner-border text-primary" />
                            </div>
                        ) : (
                            <div className="col-12 text-right">
                                <button className="btn btn-outline-success" disabled={!this.state.nomeTransportadora} onClick={this.cadastrarTransportadora}>Cadastrar</button>
                            </div>
                        )}
                    </ModalFooter>
                </Modal >
            </div >
        )
    }
}

export default CarriersList;
